<form (submit)="submitForm()" [formGroup]="form" (keydown.enter)="submitForm()" class="main-form">
  <div [class]="inModal ? 'modal-body' : 'row justify-content-center'">
    <div [class.col-md-6]="!inModal">
      <div [class.card]="!inModal">
        <div [class.card-body]="!inModal">
          <div class="form-group">
            <label for="position" [innerText]="'FLIGHT_BRIEF_CATERINGS.POSITION' | translate"></label>
            <input
              class="form-control"
              id="position"
              formControlName="position"
              type="number"
              min="0"
              required
                            [class.is-invalid]="
                                (form.touched || form.controls['position'].touched) &&
                                form.controls['position'].status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />

            <div class="invalid-tooltip">
              @if (
                (form.touched || form.controls['position'].touched) &&
                form.controls['position'].errors &&
                form.controls['position'].errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>

          <div class="list-group-header" [innerText]="'FLIGHT_BRIEF_CATERINGS.TEXT' | translate"></div>
          <ul class="list-group mb-4" formGroupName="textByLanguage">
            @for (language of getLanguages(); track language) {
              <li class="list-group-item">
                <div class="form-group mb-0">
                  <label
                    [attr.for]="'text-' + language"
                    [innerText]="getLanguageLabel(language) | translate"
                  ></label>
                  <textarea
                    class="form-control"
                    [id]="'text-' + language"
                    [formControlName]="language"
                                    [class.is-invalid]="
                                        (form.touched || getTextForLanguage(language).touched) &&
                                        getTextForLanguage(language).status === 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                    rows="2"
                  ></textarea>
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched ||
                      getTextForLanguage(language).touched) &&
                      getTextForLanguage(language).errors &&
                      getTextForLanguage(language).errors['required']
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                </div>
              </li>
            }
          </ul>

          <div class="form-group">
            <label [innerText]="'FLIGHT_BRIEF_CATERINGS.CONCERNED_DEPARTMENTS' | translate"></label>
            <div class="form-check">
              <input
                type="checkbox"
                name="enquiryTypes"
                class="form-check-input"
                id="enquiryType-all"
                                [checked]="
                                    form.value.enquiryTypes.length === getEnquiryTypes().length
                                "
                (change)="toggleAllEnquiryType()"
                />
              <label class="form-check-label" for="enquiryType-all" [innerText]="'AIRLINES.IMPORT.ALL_DEPARTMENTS' | translate"></label>
            </div>
            @if (form.value.enquiryTypes.length !== getEnquiryTypes().length) {
              @for (enquiryType of getEnquiryTypes(); track enquiryType) {
                <div class="form-check">
                  <input
                    type="checkbox"
                    name="enquiryTypes"
                    class="form-check-input"
                    [id]="'enquiryType-' + enquiryType"
                    [checked]="form.value.enquiryTypes.includes(enquiryType)"
                    (change)="toggleEnquiryType(enquiryType)"
                    />
                  <label
                    class="form-check-label"
                    [attr.for]="'enquiryType-' + enquiryType"
                    [innerText]="getEnumEnquiryTypeLabel(enquiryType) | translate"
                    >
                  </label>
                </div>
              }
            }

            <div class="invalid-tooltip">
              @if (
                (form.touched || form.controls['enquiryTypes'].touched) &&
                form.controls['enquiryTypes'].errors &&
                form.controls['enquiryTypes'].errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (!inModal) {
    <div class="row justify-content-center text-center mt-4">
      <div class="col-md-4">
        <button
          type="button"
                [routerLink]="
                    flightBriefCateringId
                        ? '/admin/flight-brief-caterings/' + flightBriefCateringId
                        : '/admin/flight-brief-caterings'
                "
          class="btn btn-secondary btn-block mb-4"
          [disabled]="form.disabled"
          [innerText]="'GENERAL.CANCEL' | translate"
        ></button>
      </div>
      <div class="col-md-4">
        <button
          type="submit"
          class="btn btn-primary btn-block mb-4"
          [disabled]="form.disabled || !form.valid"
          [innerText]="'GENERAL.SAVE' | translate"
        ></button>
      </div>
    </div>
  }

  @if (inModal) {
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeModal()"
        [innerText]="'GENERAL.CANCEL' | translate"
      ></button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="submitForm()"
        [innerText]="'GENERAL.SAVE' | translate"
      ></button>
    </div>
  }
</form>
